import { useCallback, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useWorkWithUs } from "contexts/WorkWithUs.contexts";
import countries from "utils/countries.json";
import listHeight from "utils/listHeigh.json";
import listSizesShirts from "utils/listSizesShirtsV2.json";
import listSizesTshirts from "utils/listSizesShirtsV2.json";
import listSizesShoes from "utils/listSizesShoes.json";
import listSizesPants from "utils/listSizesPants.json";
import listStates from "utils/brazilianStates.json";
import listIssuingStates from "utils/brazilianStates.json";
import Api from "service/api";
import { InputMaskCpf, InputMaskCellphone } from "components/form";

const useAdditionalInformation = () => {
  const {
    dataFields,
    errors,
    updateDataField,
    updateErrors,
    updateStatusError,
  } = useWorkWithUs();

  const { t: translate } = useTranslation();
  const [driverExpirationDate, setDriverExpirationDate] = useState(null);
  const [isCnhRequired, setCnhRequired] = useState(
    dataFields?.basicInformation?.driverLicenceCategory &&
      dataFields?.basicInformation?.driverLicenceCategory !== "NT"
      ? true
      : false
  );
  const [birthDate, setBirthDate] = useState(null);
  const [timeCourse, setTimeCourse] = useState(null);
  const [ctpsDispatchDate, setCtpsDispatchDate] = useState(null);
  const [driverFirstLicenceDate, setDriverFirstLicenceDate] = useState(null);

  const [nationalities, setNationalities] = useState([]);
  const [listCities, setListCities] = useState([]);
  const [listIssuingCities, setListIssuingCities] = useState([]);
  const [isVigilant] = useState(() => dataFields.typeOfVacancy.type === "1");
  const [openModal, setOpenModal] = useState(false);




  const handleChangeText = useCallback(
    ({ target }, item, fn = () => {}) => {
      updateDataField(item, {
        ...{ ...dataFields[item], [target.name]: target.value },
      });

      updateErrors(item, {
        ...{ ...errors[item], [target.name]: false },
      });
      updateStatusError(false);
      fn();
    },
    [dataFields, errors, updateDataField, updateErrors, updateStatusError]
  );


  const handleChangeSelect = useCallback(
    ({ target }, item) => {
      updateDataField(item, {
        ...{ ...dataFields[item], [target.name]: target.value },
      });

      updateErrors(item, {
        ...{ ...errors[item], [target.name]: false },
      });
      updateStatusError(false);
    },
    [dataFields, errors, updateDataField, updateErrors, updateStatusError]
  );


  const handleChangeCheckbox = useCallback(
    ({ target }, item, fn = () => {}) => {
      const checked = !dataFields?.basicInformation?.[target.name];

      updateDataField(item, {
        ...{
          ...dataFields[item],
          [target.name]: checked,
        },
      });

      fn();
    },
    [dataFields, updateDataField]
  );

  const setCountriesNationalities = useCallback(() => {
    let allNationalities = countries.map((country) => {
      return country.gentilico;
    });

    allNationalities = allNationalities.sort();

    allNationalities = allNationalities.map((nationality) => {
      return {
        label: nationality,
        value: nationality,
      };
    });

    setNationalities(allNationalities);
  }, []);

  useEffect(() => {
    setCountriesNationalities();
  }, [setCountriesNationalities]);

  const fetchCities = async (uf) => {
    if (uf) {
      const res = await Api.get(`cities-ibge/${uf}`);
      if (res.data.cidades.length > 0) {
        const cities = res.data.cidades.map((item) => {
          return {
            label: item.nome,
            value: item.nome,
          };
        });
        setListCities(cities);
      }
    }
  };

  const fetchIssuingCities = async (uf) => {
    if (uf) {
      const res = await Api.get(`cities-ibge/${uf}`);
      if (res.data.cidades.length > 0) {
        const cities = res.data.cidades.map((item) => {
          return {
            label: item.nome,
            value: item.nome,
          };
        });
        setListIssuingCities(cities);
      }
    }
  };

  const handleCloseModal = useCallback(() => {
    setOpenModal(false);
  }, []);

  const initBirthDate = useCallback(() => {
    setBirthDate(dataFields.basicInformation?.birthDate || null);
  }, []);

  const initTimeCourse = useCallback(() => {
    setTimeCourse(dataFields.basicInformation?.timeCourse || null);
  }, []);

  const initCtpsDispatchDate = useCallback(() => {
    setCtpsDispatchDate(dataFields.basicInformation?.ctpsDispatchDate || null);
  }, []);

  const initDriverExpirationDate = useCallback(() => {
    setDriverExpirationDate(
      dataFields.basicInformation?.driverExpirationDate || null
    );
  }, []);

  const initDriverFirstLicenceDate = useCallback(() => {
    setDriverFirstLicenceDate(
      dataFields.basicInformation?.driverFirstLicenceDate || null
    );
  }, []);

  const init = useCallback(() => {
    initBirthDate();
    initTimeCourse();
    initCtpsDispatchDate();
    initDriverExpirationDate();
    initDriverFirstLicenceDate();
  }, [
    initBirthDate,
    initTimeCourse,
    initCtpsDispatchDate,
    initDriverExpirationDate,
    initDriverFirstLicenceDate,
  ]);

  useEffect(() => {
    init();
  }, [init]);

  useEffect(() => {
    if (dataFields.basicInformation?.naturalnessState) {
      fetchCities(dataFields.basicInformation?.naturalnessState).catch(
        console.error
      );
    }
  }, []);

  useEffect(() => {
    if (dataFields.basicInformation?.rgIssuingState) {
      fetchIssuingCities(dataFields.basicInformation?.rgIssuingState).catch(
        console.error
      );
    }
  }, []);

  return {
    dataFields,
    errors,
    isVigilant,
    listHeight,
    listSizesShoes,
    listSizesShirts,
    listSizesTshirts,
    listSizesPants,
    openModal,
    translate,
    handleCloseModal,
    handleChangeText,
    handleChangeSelect,
    handleChangeCheckbox,
  };
};

export default useAdditionalInformation;
